import api from "./api";

export async function login(identifier: string, password: string) {
  // `identifier` may be an email or a username. We send it as `identifier`
  // (preferred by the backend) and also as `email` for backward compatibility.
  const { data } = await api.post("/auth/login", { identifier, email: identifier, password });
  return data; // { token, user }
}

export async function register(email: string, password: string, name?: string) {
  const { data } = await api.post("/auth/register", { email, password, name });
  return data;
}

/**
 * Ask for the activation email again.
 *
 * Answers the same thing whatever the account's state is — the server will not
 * say whether the address exists — so the caller shows one confirmation and
 * does not branch on the reply.
 */
export async function resendActivation(identifier: string) {
  const { data } = await api.post("/auth/resend-activation", { identifier });
  return data as { message: string };
}

export async function getMyClubs() {
  const { data } = await api.get("/clubs");
  return data; // [{ role, club }]
}
